import * as React from 'react'
import styled from 'styled-components'
import { VideoData } from '../../../interfaces'
// import { Tab, Tabs, useMediaQuery } from '@material-ui/core'
// import { styled as styling } from '@material-ui/styles'
// import SwipeableViews from 'react-swipeable-views'
import { PRIMARY_SUBSCRIPTION, SECONDARY_SUBSCRIPTION } from '../../../graphql/graphql-queries'
import { useSubscription } from '@apollo/client'
import { Query_Root } from '../../../graphql/indexer-graphql-types'
// import ListingsDetails from './ListingsDetails'
// // import OffersDetails from './OffersDetails'
// import { useAtom } from 'jotai'
// import { rwBuySellDialogAtom } from '../../../atoms/SecondaryDialog'
import { LAMPORTS_PER_SOL } from '@solana/web3.js'

const OuterDiv = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 12px;
  padding-right: 12px;

  @media (min-width: 43em) {
    padding: 0;
  }

  @media (min-width: 62em) {
    padding: 0;
  }

  @media (min-width: 62em) {
    width: 100%;
  }
`

const Title = styled.div`
  color: white;
  font-size: 22px;
  font-weight: 700;
  text-align: left;
  margin-bottom: 10px;

  @media (min-width: 43em) {
    font-size: 40px;
  }
`

const SecondaryDiv = styled.div`
  background: linear-gradient(rgb(35, 35, 35), rgb(20, 20, 20));
  border-radius: 15px;
  padding: 15px;

  border-color: #323232;
  border-width: 1px;
  border-style: solid;

  margin-top: 15px;
  width: calc(100%-30px);

  @media (min-width: 43em) {
    padding: 25px;
    margin-top: 25px;
    width: calc(100%-50px);
  }
`

// const SwipeDiv = styled.div`
//   display: flex;
//   flex: 1;
//   width: 100%;
//   flex-direction: row;
//   justify-content: center;
//   align-items: center;
// `

// const ScrollDiv = styled.div`
//   min-height: 0;
//   max-height: 500px;
//   overflow-y: scroll;
//   height: fit-content;
// `

const StatsDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 10px;
  gap: 10px;

  @media (min-width: 43em) {
    gap: 20px;
  }
`

const StatDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #aaa;
  background: #232323;

  @media (min-width: 43em) {
    gap: 15px;
  }
`

const StatTitle = styled.div`
  color: white;
  font-size: 12px;
  font-weight: 500;

  @media (min-width: 43em) {
    font-size: 14px;
  }
`

const StatValue = styled.div`
  color: white;
  font-size: 12px;
  font-weight: 700;

  @media (min-width: 43em) {
    font-size: 14px;
  }
`

// const StyledTabs = styling(Tabs)({
//   borderBottom: '1px solid #323232',
//   '& .MuiTabs-indicator': {
//     backgroundColor: 'white',
//   },
//   '& .MuiTabs-scrollButtons.Mui-disabled': {
//     opacity: 0.3,
//   },
// })

// const StyledTab = styling((props) => <Tab disableRipple {...props} />)((props) => ({
//   textTransform: 'none',
//   minWidth: 0,
//   fontWeight: 700,
//   opacity: 1,
//   fontSize: props.isMobile ? '18px' : '26px',
//   textAlign: 'left',
//   padding: 0,
//   paddingBottom: '10px',
//   marginRight: props.label !== '' ? (props.isMobile ? '25px' : '50px') : '0px',
//   color: '#aaa',
//   fontFamily: [
//     'Inter',
//     '-apple-system',
//     'BlinkMacSystemFont',
//     '"Segoe UI"',
//     'Roboto',
//     '"Helvetica Neue"',
//     'Arial',
//     'sans-serif',
//     '"Apple Color Emoji"',
//     '"Segoe UI Emoji"',
//     '"Segoe UI Symbol"',
//   ].join(','),
//   '&:hover': {
//     color: 'white',
//     opacity: 1,
//   },
//   '&.Mui-selected': {
//     color: 'white',
//   },
// }))

type Props = {
  video: VideoData
}

const MonetizationDetails = ({ video }: Props): JSX.Element => {
  const [index, setIndex] = React.useState(0)
  const [oldCount, setOldCount] = React.useState(0)
  // const [swipeableActions, setSwipeableActions] = React.useState<any | undefined>(undefined)
  // const isMobile = useMediaQuery('(max-width: 43em)')
  // const [open] = useAtom(rwBuySellDialogAtom)
  const primaryData = useSubscription<Query_Root>(PRIMARY_SUBSCRIPTION, {
    variables: {
      mint: video.address,
    },
  }).data
  const secondaryData = useSubscription<Query_Root>(SECONDARY_SUBSCRIPTION, {
    variables: {
      mint: video.address,
    },
  }).data

  const primaryMint = primaryData?.mint[0]
  const secondaryMint = secondaryData?.mint[0]
  const { metadataObject } = secondaryMint?.editionMetadata || {}
  const { max } = metadataObject?.bidReceiptsAggregate?.aggregate || {}
  const maxPrice = max?.price || 0
  const minPrice = secondaryMint?.floorPriceObject?.floor || 0
  const { count } = secondaryMint?.listingsWithTokenAggregate?.aggregate || {}
  const hasListings = minPrice > 0
  const hasOffers = maxPrice > 0

  React.useEffect(() => {
    let count = 0
    if (hasListings && hasOffers) {
      count = 2
    } else if (hasListings) {
      count = 1
      if (oldCount !== 1 && index === 1) {
        setIndex(0)
      }
    } else if (hasOffers) {
      count = 1
      if (oldCount !== 1 && index === 0) {
        setIndex(1)
      }
    }
    setOldCount(count)
  }, [hasListings, hasOffers])

  return (
    <OuterDiv>
      {(hasListings || hasOffers) && (
        <SecondaryDiv>
          <Title>Secondary Market</Title>
          <StatsDiv>
            <StatDiv>
              <StatTitle>FLOOR</StatTitle>
              <StatValue>
                {Math.round((secondaryMint?.floorPriceObject?.floor / LAMPORTS_PER_SOL) * 100) /
                  100}{' '}
                SOL
              </StatValue>
            </StatDiv>
            <StatDiv>
              <StatTitle>VOLUME</StatTitle>
              <StatValue>
                {Math.round(
                  ((metadataObject?.purchaseReceiptsAggregate.aggregate?.sum?.price +
                    primaryMint?.supply * primaryMint?.editionMetadata?.primarySalePrice) /
                    LAMPORTS_PER_SOL) *
                    100
                ) / 100}{' '}
                SOL
              </StatValue>
            </StatDiv>
            <StatDiv>
              <StatTitle>OWNERS</StatTitle>
              <StatValue>{secondaryMint?.tokenAccountsAggregate.aggregate?.count ?? 0}</StatValue>
            </StatDiv>
            <StatDiv>
              <StatTitle>LISTED</StatTitle>
              <StatValue>{count}</StatValue>
            </StatDiv>
            <StatDiv>
              <StatTitle>SUPPLY</StatTitle>
              <StatValue>{secondaryMint?.supply}</StatValue>
            </StatDiv>
          </StatsDiv>
          {/* <StyledTabs
            value={index}
            onChange={(_e, newValue) => setIndex(newValue)}
            aria-label="ant example"
            variant="scrollable"
            scrollButtons="auto"
          >
            {hasListings ? (
              <StyledTab isMobile={isMobile} label="Listings" />
            ) : (
              <StyledTab isMobile={isMobile} label="" />
            )}
            {hasOffers ? (
              <StyledTab isMobile={isMobile} label="Offers" />
            ) : (
              <StyledTab isMobile={isMobile} label="" />
            )}
          </StyledTabs>
          <SwipeDiv>
            <SwipeableViews
              style={{
                width: '100%',
              }}
              axis={'x'}
              index={index}
              onSwitching={setIndex}
              animateHeight={true}
              action={
                ((actions: any) => {
                  setSwipeableActions(actions)
                }) as any
              }
            >
              {hasListings ? (
                <ScrollDiv>
                  <ListingsDetails
                    refresh={open.refresh === SECONDARY_ACTION.SELL}
                    updateHeight={() => swipeableActions?.updateHeight()}
                    currentIndex={index}
                    index={0}
                    video={video}
                  />
                </ScrollDiv>
              ) : (
                <></>
              )}
              {hasOffers ? (
                <ScrollDiv>
                  <OffersDetails
                    refresh={open.refresh === SECONDARY_ACTION.BUY}
                    updateHeight={() => swipeableActions?.updateHeight()}
                    currentIndex={index}
                    index={1}
                    video={video}
                  />
                </ScrollDiv>
              ) : (
                <></>
              )}
            </SwipeableViews>
          </SwipeDiv> */}
        </SecondaryDiv>
      )}
    </OuterDiv>
  )
}

export default MonetizationDetails
